module.exports = __webpack_public_path__ + "img/img_banner_project_1.1afa4e89.jpg";